
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useOrders } from "../../pages/DefaultPage/connect/Orders";
import { useLocations } from "../../States/Location/Location";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroller";
import OneCard from "../ADUser/OneCard";
import TwoCard from "../ADUser/TwoCard";
import { baseUrl } from "../../baseurl";
import { ADS_MainCategoryCode } from "../../SharedData";
import { ADS_PropertyTypeCode } from "../../SharedData";
import { ADS_PropertyTradeTypeCode } from "../../SharedData";
import Loader from "../Loader/Loader";
import { Link, useNavigate } from "react-router-dom";
import { Grid } from "antd";
function NewFilter(props) {
    const { getDetailMasterByQueryByAllStrings, addStoreItem, setHasMoreStore, addItemsInStore, getAuctionDetailMasterByQuery, clearAuctionItems, getDetailMasterByQueryNew, clearItemsInStore } = useOrders((state) => state.actions);
    const allAuctionAds = useOrders((state) => state.allAuctionAds);
    console.log(props?.userCode);

    useEffect(() => {
        if (!auctionItems?.length) setAuctionItems(allAuctionAds)

        console.log("this happened");

    }, [allAuctionAds])



    console.log("ojgjgjgjh", props.isSearch);
    console.log(window.location.pathname, "window.location.pathname");



    const [isFilterPrice, setIsFilterPrice] = useState(false)
    // import stors and actions from zustand (start)
    const storeItems = useOrders((state) => state.storeItems);

    // const isSearch = useOrders((state) => state.isSearch);

    const citiess = useLocations((state) => state.cities)
    const loader = useOrders((state) => state.loader);
    const [checkLoadData, setCheckLoadData] = useState(false)
    const [hasMoreThanStoreItems, setHasMoreThanStoreItems] = useState(false)
    const bottomBoundaryRef = useRef(null);
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    // import stors and actions from zustand (end)


    useEffect(() => {
        if (bottomBoundaryRef.current) {
            setHasMoreThanStoreItems(true)
        }
    }, [bottomBoundaryRef.current])



    // states for get values from user (start)
    const [parking, setParking] = useState(null)
    const [basement, setbasement] = useState(null)
    const [elevator, setElevator] = useState(null)
    const [isShowFilters, setIsShowFilters] = useState(false)
    const [moveToSelectArea, setMoveToSelectArea] = useState(false)
    const [isShowChoseCategoryPage, setIsShowChoseCategoryPage] = useState(false)
    const [selectedCategoryItem, setSelectedCategoryItem] = useState(0)
    const [isShowChoseMElkTypePage, setIsShowChoseMElkTypePage] = useState(false)
    const [selectedMelkTypeItem, setSelectedMelkTypeItem] = useState(0)
    const [isShowChoseMoamelePage, setIsShowChoseMoamelePage] = useState(false)
    const [selectedMelkMoameleItem, setSelectedMelkMoameleItem] = useState(0)
    const [isShowDeposit, setIsDeposit] = useState(false)
    const [isShowRentPerMonth, setIsShowRentPerMonth] = useState(false)
    const [isShowPrice, setIsShowPrice] = useState(false)
    const [isShowOptions, setIsShowOptions] = useState(false)
    const [isShowMetrage, setIsShowMetrage] = useState(false)
    const [isShowLife, setIsShowLife] = useState(false)
    const [selectedAreas, setSelectedAreas] = useState([])
    const [adsAdvertiseTypeCode, setAdsAdvertiseTypeCode] = useState(0)
    const [type, setType] = useState(false)
    const [priceFrom, setPriceFrom] = useState()
    const [priceTo, setPriceTo] = useState()
    const [meterageFrom, setMeterageFrom] = useState()
    const [meterageTo, setMeterageTo] = useState()
    const [buldingLifeFrom, setBuldingLifeFrom] = useState()
    const [buldingLifeTo, setBuldingLifeTo] = useState()
    const [depositFrom, setDepositFrom] = useState()
    const [depositTo, setDepositTo] = useState()
    const [rentFrom, setRentFrom] = useState()
    const [rentTo, setRentTo] = useState()
    const [noeAgahiDahande, setNoAgahiDahande] = useState(0)
    const [isShowTypeAdsDahande, setIsShowAdsDahande] = useState(false)
    const [cityState, setCityState] = useState([citiess])
    const [searchInCitiesValue, setSearchInCitiesValue] = useState("")
    const [items, setItems] = useState([]);
    const [auctionItems, setAuctionItems] = useState([]);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true)
    const [selectedAreasIDs, setSelectedAreasIDs] = useState([])
    const navigate = useNavigate();
    const [propertyCodeName, setPropertyCodeName] = useState("")
    const [searchValue, setSearchValue] = useState(localStorage?.getItem("searchValue") || '')
    const [removedCategoryFromFilter, setRemovedCategoryFromFilter] = useState(false)

    // states for get values from user (end)


    // this states add to api (start)
    const [dailyPriceFrom, setDailyPriceFrom] = useState()
    const [dailyPriceTo, setDailyPriceTo] = useState()
    const [isShowDailyPrice, setIsShowDailyPrice] = useState()
    const [pricePerMeterFrom, setPricePerMeterFrom] = useState()
    const [pricePerMeterTo, setPricePerMeterTo] = useState()
    const [isShowPricePerMeter, setIsShowPricePerMeter] = useState()
    const [priceTotalFrom, setPriceTotalFrom] = useState()
    const [priceTotalTo, setPriceTotalTo] = useState()
    const [isShowPriceTotal, setIsShowPriceTotal] = useState()
    const [isFetchData, setIsFetchData] = useState(false)
    const [loaderFetch, setLoaderFetch] = useState(false)
    // this states add to api (end)



    //   kole mahaleha
    // console.log(cityState, "cityState");

    console.log(selectedAreasIDs, "cityState selectedAreasIDs");
    console.log(selectedAreas, "cityState selectedAreas");

    // [
    //     {
    //         "id": 4,
    //         "locName": "آبشار",
    //         "locParentId": 3,
    //         "masterId": 4,
    //         "subAreas": [
    //             "هفده شهریور",
    //             "ری",
    //             "خیابان آبشار",
    //             "گوته",
    //             "محلاتی"
    //         ]
    //     }
    // ]
    useEffect(() => {
        clearAuctionItems()
        console.log("clearAuctionItems() clearAuctionItems() ");

    }, [selectedCategoryItem, props?.isFilterWithPropertyCode])
 




    const renderImage = () => {
        const path = window.location.pathname;
        const isDesktop = screens.lg;
        const getImagePath = (suffix) => `/baners/${isDesktop ? "desktop" : "mobile"}/${suffix}`;
        switch (path) {
            case "/metals":
                return <img src={getImagePath("mobile-b-06.webp")} alt="metals" className="w-[97%] rounded-lg" />;
            case "/property":
                return <img src={getImagePath("mobile-b-07.webp")} alt="property" className="w-[97%] rounded-lg" />;
            case "/buildingMaterials":
                return <img src={getImagePath("mobile-b-08.webp")} alt="buildingMaterials" className="w-[97%] rounded-lg" />;
            case "/services-labor":
                return <img src={getImagePath("mobile-b-05.webp")} alt="services-labor" className="w-[97%] rounded-lg" />;
            case "/architect-contractor":
                return <img src={getImagePath("mobile-b-02.webp")} alt="architect-contractor" className="w-[97%] rounded-lg" />;
            case "/machine-tools":
                return <img src={getImagePath("mobile-b-03.webp")} alt="/machine-tools" className="w-[97%] rounded-lg" />;
            case "/equipment":
                return <img src={getImagePath("mobile-b-04.webp")} alt="/equipment" className="w-[97%] rounded-lg" />;
            default:
                return <></>;
        }
    };



    const fetchData = async (__page) => {
        if (isFetchData) {
            console.log(" GetDetailMasterByQuery 2");
            setLoaderFetch(true)



            if (props.userCode && !checkLoadData) {
                // setItems([]);
                console.log(" GetDetailMasterByQuery 3");
                axios.post(`${baseUrl}/Advertise/GetDetailMasterByQueryNew`, {
                    "page": page,
                    "adsMainCategoryCode": props.isFilterWithPropertyCode ? Number(props.isFilterWithPropertyCode) : Number(selectedCategoryItem !== 0 ? selectedCategoryItem.id : 0),
                    "userCode": props.userCode ? props.userCode : 0,
                    "adsAdvertiseTypeCode": adsAdvertiseTypeCode ? Number(adsAdvertiseTypeCode) : 0,
                    "adsPrptyTradeTypeCode":
                        selectedMelkMoameleItem ? [Number(selectedMelkMoameleItem.id)] : [],
                    "adsPrptyTypeCode": selectedMelkTypeItem ? [Number(selectedMelkTypeItem.id)] : [],
                    "userTypeCode": noeAgahiDahande ? [Number(noeAgahiDahande)] : [],
                    "countryCode": 0,
                    "stateCode": 0,
                    "cityCode": 0,
                    "areaCode": selectedAreasIDs[0],
                    "priceFrom": priceFrom ? priceFrom : 0,
                    "priceTo": priceTo ? priceTo : 0,
                    "depositFrom": depositFrom ? depositFrom : 0,
                    "depositTo": depositTo ? depositTo : 0,
                    "rentFrom": rentFrom ? rentFrom : 0,
                    "rentTo": rentTo ? rentTo : 0,
                    "meterageFrom": meterageFrom ? meterageFrom : 0,
                    "meterageTo": meterageTo ? meterageTo : 0,
                    "buldingLifeFrom": buldingLifeFrom ? buldingLifeFrom : 0,
                    "buldingLifeTo": buldingLifeTo ? buldingLifeTo : 0,
                    "adsDateTimeFrom": null,
                    "adsDateTimeTo": null,
                    "parking": parking,
                    "basement": basement,
                    "elevator": elevator,
                    "searchQuery": /* props.searchValue */localStorage?.getItem("searchValue"),
                }, (localStorage.getItem("veeuAuthData") == props.userCode) && {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                    },
                }
                )
                    .then(async (res) => {
                        setLoaderFetch(false)
                        if (res.data.length) {
                            setItems([...items, ...res.data]);
                            setPage(page + 20);
                        }
                        else {
                            setHasMore(false)
                            setIsFetchData(false)
                        }
                    })
            } else {
                if (!checkLoadData) {
                    // setCheckLoadData(true)
                    console.log(" GetDetailMasterByQuery 4");
                    (!props.isSearch) &&
                        axios.post(`${baseUrl}/Advertise/GetDetailMasterByQueryNew`, {
                            "page": storeItems.length !== 0 ? Number(localStorage.getItem("page")) : page,
                            "adsMainCategoryCode": props.isFilterWithPropertyCode ? Number(props.isFilterWithPropertyCode) : Number(selectedCategoryItem !== 0 ? selectedCategoryItem.id : 0),
                            "userCode": props.userCode ? props.userCode : 0,
                            "adsAdvertiseTypeCode": adsAdvertiseTypeCode ? Number(adsAdvertiseTypeCode) : 0,
                            "adsPrptyTradeTypeCode":
                                selectedMelkMoameleItem ? [Number(selectedMelkMoameleItem.id)] : []
                            ,
                            "adsPrptyTypeCode":
                                selectedMelkTypeItem ? [Number(selectedMelkTypeItem.id)] : []
                            ,
                            "userTypeCode":
                                noeAgahiDahande ? [Number(noeAgahiDahande)] : []
                            ,
                            "countryCode": 0,
                            "stateCode": 0,
                            "cityCode": 0,
                            "areaCode": selectedAreasIDs[0],
                            "priceFrom": priceFrom ? priceFrom : 0,
                            "priceTo": priceTo ? priceTo : 0,
                            "depositFrom": depositFrom ? depositFrom : 0,
                            "depositTo": depositTo ? depositTo : 0,
                            "rentFrom": rentFrom ? rentFrom : 0,
                            "rentTo": rentTo ? rentTo : 0,
                            "meterageFrom": meterageFrom ? meterageFrom : 0,
                            "meterageTo": meterageTo ? meterageTo : 0,
                            "buldingLifeFrom": buldingLifeFrom ? buldingLifeFrom : 0,
                            "buldingLifeTo": buldingLifeTo ? buldingLifeTo : 0,
                            "adsDateTimeFrom": null,
                            "adsDateTimeTo": null,
                            "parking": parking,
                            "basement": basement,
                            "elevator": elevator,
                            "searchQuery": /* props.searchValue */localStorage?.getItem("searchValue"),
                        },
                            {
                                headers: {
                                    Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                                },
                            })
                            .then((res) => {
                                setLoaderFetch(false)
                                if (res.data.length) {
                                    setItems([...items, ...res.data]);
                                    setPage(page + 20);
                                }
                                else {
                                    setHasMore(false)
                                }
                            })
                }
            }
        }


        // (isFetchData) &&
        //     setLoaderFetch(true)
        // await axios.post(`${baseUrl}/Advertise/GetDetailMasterByQueryNew`, {
        //     "page": storeItems.length !== 0 ? Number(localStorage.getItem("page")) : page,
        //     "adsMainCategoryCode": props.isFilterWithPropertyCode ? Number(props.isFilterWithPropertyCode) : Number(selectedCategoryItem !== 0 ? selectedCategoryItem.id : 0),
        //     "userCode": props.userCode ? props.userCode : 0,
        //     "adsAdvertiseTypeCode": adsAdvertiseTypeCode ? Number(adsAdvertiseTypeCode) : 0,
        //     "adsPrptyTradeTypeCode": [
        //         selectedMelkMoameleItem ? Number(selectedMelkMoameleItem.id) : 0
        //     ],
        //     "adsPrptyTypeCode": [
        //         selectedMelkTypeItem ? Number(selectedMelkTypeItem.id) : 0
        //     ],
        //     "userTypeCode": [
        //         noeAgahiDahande ? Number(noeAgahiDahande) : 0
        //     ],
        //     "countryCode": 0,
        //     "stateCode": 0,
        //     "cityCode": 0,
        //     "areaCode": selectedAreasIDs[0],
        //     "priceFrom": priceFrom ? priceFrom : 0,
        //     "priceTo": priceTo ? priceTo : 0,
        //     "depositFrom": depositFrom ? depositFrom : 0,
        //     "depositTo": depositTo ? depositTo : 0,
        //     "rentFrom": rentFrom ? rentFrom : 0,
        //     "rentTo": rentTo ? rentTo : 0,
        //     "meterageFrom": meterageFrom ? meterageFrom : 0,
        //     "meterageTo": meterageTo ? meterageTo : 0,
        //     "buldingLifeFrom": buldingLifeFrom ? buldingLifeFrom : 0,
        //     "buldingLifeTo": buldingLifeTo ? buldingLifeTo : 0,
        //     "adsDateTimeFrom": null,
        //     "adsDateTimeTo": null,
        //     "parking": parking,
        //     "basement": basement,
        //     "elevator": elevator,
        //     "searchQuery": props.searchValue
        // })
        //     .then(async (res) => {
        //         setLoaderFetch(false)
        //         if (res.data.length) {
        //             setItems([...items, ...res.data]);
        //             setPage(page + 20);
        //         }
        //         else {
        //             setHasMore(false)
        //         }
        //     })
    };


    const filter = async () => {
        setLoaderFetch(true)
        clearItemsInStore()
        console.log(" GetDetailMasterByQuery 5");
        selectedAreasIDs.push(selectedAreas.map(area => area.id))
        const adsMainCategoryCode = props.isFilterWithPropertyCode ? Number(props.isFilterWithPropertyCode) : Number(selectedCategoryItem !== 0 ? selectedCategoryItem.id : 0)
        if (adsMainCategoryCode !== 1 || adsMainCategoryCode !== 0) {
            console.log("are we here?");

            clearAuctionItems()
        }
        if (adsMainCategoryCode == 1 || adsMainCategoryCode == 0) {
            getAuctionDetailMasterByQuery(
            /* "page": */ 0,
            /* "adsMainCategoryCode": */ adsMainCategoryCode,
            /* "userCode":  */props.userCode ? props.userCode : 0,
           /*  "adsAdvertiseTypeCode": */ adsAdvertiseTypeCode ? Number(adsAdvertiseTypeCode) : 0,
            /* "adsPrptyTradeTypeCode": */selectedMelkMoameleItem ? [Number(selectedMelkMoameleItem.id)] : [],
            /* "adsPrptyTypeCode":  */selectedMelkTypeItem ? [Number(selectedMelkTypeItem.id)] : [],
           /*  "userTypeCode": */ noeAgahiDahande ? [Number(noeAgahiDahande)] : [],
           /*  "countryCode": */ 0,
            /* "stateCode": */ 0,
           /*  "cityCode": */ 0,
           /*  "areaCode": */ selectedAreasIDs[0],
            /* "priceFrom": */ priceFrom ? priceFrom : 0,
           /*  "priceTo": */ priceTo ? priceTo : 0,
            /* "depositFrom": */ depositFrom ? depositFrom : 0,
            /* "depositTo":  */depositTo ? depositTo : 0,
           /*  "rentFrom": */ rentFrom ? rentFrom : 0,
            /* "rentTo": */ rentTo ? rentTo : 0,
            /* "meterageFrom": */ meterageFrom ? meterageFrom : 0,
            /* "meterageTo": */ meterageTo ? meterageTo : 0,
            /* "buldingLifeFrom": */ buldingLifeFrom ? buldingLifeFrom : 0,
            /* "buldingLifeTo": */ buldingLifeTo ? buldingLifeTo : 0,
            /* "adsDateTimeFrom": */ null,
            /* "adsDateTimeTo": */ null,
           /*  "parking": */ parking,
            /* "basement": */ basement,
            /* "elevator": */ elevator,
           /*  "searchQuery": *//*  props.isSearch ? props.searchValue : "" */localStorage?.getItem("searchValue"),

            )
        }


        await axios.post(`${baseUrl}/Advertise/GetDetailMasterByQueryNew`, {
            "page": 0,
            "adsMainCategoryCode": adsMainCategoryCode,
            "userCode": props.userCode ? props.userCode : 0,
            "adsAdvertiseTypeCode": adsAdvertiseTypeCode ? Number(adsAdvertiseTypeCode) : 0,
            "adsPrptyTradeTypeCode":
                selectedMelkMoameleItem ? [Number(selectedMelkMoameleItem.id)] : [],
            "adsPrptyTypeCode":
                selectedMelkTypeItem ? [Number(selectedMelkTypeItem.id)] : [],
            "userTypeCode":
                noeAgahiDahande ? [Number(noeAgahiDahande)] : [],
            "countryCode": 0,
            "stateCode": 0,
            "cityCode": 0,
            "areaCode": selectedAreasIDs[0],
            "priceFrom": priceFrom ? priceFrom : 0,
            "priceTo": priceTo ? priceTo : 0,
            "depositFrom": depositFrom ? depositFrom : 0,
            "depositTo": depositTo ? depositTo : 0,
            "rentFrom": rentFrom ? rentFrom : 0,
            "rentTo": rentTo ? rentTo : 0,
            "meterageFrom": meterageFrom ? meterageFrom : 0,
            "meterageTo": meterageTo ? meterageTo : 0,
            "buldingLifeFrom": buldingLifeFrom ? buldingLifeFrom : 0,
            "buldingLifeTo": buldingLifeTo ? buldingLifeTo : 0,
            "adsDateTimeFrom": null,
            "adsDateTimeTo": null,
            "parking": parking,
            "basement": basement,
            "elevator": elevator,
            "searchQuery": /* props.searchValue */localStorage?.getItem("searchValue"),
        },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                },
            })
            .then((res) => {
                setLoaderFetch(false)
                if (res.data.length) {
                    setItems(res.data);
                    // setPage(page + 20)
                } else {
                    setHasMore(false)
                }
            })
        setIsShowChoseCategoryPage(false)
        setIsShowFilters(false)
        setIsShowChoseMElkTypePage(false)
        setIsShowChoseMoamelePage(false)
        setMoveToSelectArea(false)

    }
    useEffect(()=>{
        filter()
        
                
        },[removedCategoryFromFilter])
    useEffect(() => {
        switch (props.isFilterWithPropertyCode) {
            case "2":
                setPropertyCodeName("آهن و فلزات")
                break;
            case "3":
                setPropertyCodeName("مصالح ساختمانی")
                break;
            case "4":
                setPropertyCodeName("ماشین آلات و ابزار")
                break;
            case "5":
                setPropertyCodeName("تاسیسات و تجهیزات")
                break;
            case "6":
                setPropertyCodeName("نیروی کار ساختمانی")
                break;
            case "7":
                setPropertyCodeName("معماری و پیمانکاری")
                break;

            default:
        }
    }, [selectedCategoryItem, selectedMelkTypeItem, selectedMelkMoameleItem, selectedAreas, moveToSelectArea, adsAdvertiseTypeCode, noeAgahiDahande, selectedAreasIDs])
    console.log(isFetchData, "isFetchDatadkvb");
    useEffect(() => {
        if (!props.userCode && props.isSearch) {
            setLoaderFetch(true)
            setItems([]);

            console.log(" GetDetailMasterByQuery 1");


            axios.post(`${baseUrl}/Advertise/GetDetailMasterByQueryNew`, {
                "page": 0,
                "adsMainCategoryCode": props.isFilterWithPropertyCode ? Number(props.isFilterWithPropertyCode) : Number(selectedCategoryItem !== 0 ? selectedCategoryItem.id : 0),
                "userCode": props.userCode ? props.userCode : 0,
                "adsAdvertiseTypeCode": adsAdvertiseTypeCode ? Number(adsAdvertiseTypeCode) : 0,
                "adsPrptyTradeTypeCode":
                    selectedMelkMoameleItem ? [Number(selectedMelkMoameleItem.id)] : [],
                "adsPrptyTypeCode":
                    selectedMelkTypeItem ? [Number(selectedMelkTypeItem.id)] : [],
                "userTypeCode":
                    noeAgahiDahande ? [Number(noeAgahiDahande)] : [],
                "countryCode": 0,
                "stateCode": 0,
                "cityCode": 0,
                "areaCode": selectedAreasIDs[0],
                "priceFrom": priceFrom ? priceFrom : 0,
                "priceTo": priceTo ? priceTo : 0,
                "depositFrom": depositFrom ? depositFrom : 0,
                "depositTo": depositTo ? depositTo : 0,
                "rentFrom": rentFrom ? rentFrom : 0,
                "rentTo": rentTo ? rentTo : 0,
                "meterageFrom": meterageFrom ? meterageFrom : 0,
                "meterageTo": meterageTo ? meterageTo : 0,
                "buldingLifeFrom": buldingLifeFrom ? buldingLifeFrom : 0,
                "buldingLifeTo": buldingLifeTo ? buldingLifeTo : 0,
                "adsDateTimeFrom": null,
                "adsDateTimeTo": null,
                "parking": parking,
                "basement": basement,
                "elevator": elevator,
                "searchQuery": /* props.isSearch ? props.searchValue : "" */localStorage?.getItem("searchValue"),
                // (localStorage.getItem("veeuAuthData") == props.userCode) &&
            }, (localStorage.getItem("veeuAuthData") == props.userCode) && {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                },
            }
            )
                .then(async (res) => {
                    setLoaderFetch(false)
                    if (res.data.length) {
                        setItems(res.data);
                        // setItems([...items, ...res.data]);
                        setPage(page + 20);
                    }
                    else {
                        setHasMore(false)
                    }
                })
        }
    }, [props.isSearch])


    useEffect(() => {
        console.log("search value changedddddd");

        // Function to handle storage events (cross-tab changes)
        const handleStorageChange = (event) => {
            if (event.key === 'searchValue') {
                setSearchValue(event.newValue);
            }
        };

        // Add listener for storage events
        window.addEventListener('storage', handleStorageChange);

        // Function to handle changes within the same tab
        const handleSameTabChange = () => {
            const currentSearchValue = localStorage.getItem('searchValue');
            if (currentSearchValue !== searchValue) {
                setSearchValue(currentSearchValue);
            }
        };

        // Polling to detect changes within the same tab
        const intervalId = setInterval(handleSameTabChange, 1000); // Check every second

        // Cleanup listeners and interval on component unmount
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            clearInterval(intervalId);
        };
    }, [searchValue]); // Re-run effect when searchValue changes
    useEffect(() => {
        // Call the API whenever searchValue changes
        // if (searchValue) {
        console.log('searchValue changed to:', searchValue);
        getAuctionDetailMasterByQuery(
                /* "page": */ 0,
                /* "adsMainCategoryCode": */ 0,
                /* "userCode":  */0,
               /*  "adsAdvertiseTypeCode": */ 0,
                /* "adsPrptyTradeTypeCode": */[],
                /* "adsPrptyTypeCode":  */[],
               /*  "userTypeCode": */[],
               /*  "countryCode": */ 1,
                /* "stateCode": */ 2,
               /*  "cityCode": */ 3,
               /*  "areaCode": */[],
                /* "priceFrom": */ 0,
               /*  "priceTo": */  0,
                /* "depositFrom": */  0,
                /* "depositTo":  */ 0,
               /*  "rentFrom": */ 0,
                /* "rentTo": */  0,
                /* "meterageFrom": */  0,
                /* "meterageTo": */  0,
                /* "buldingLifeFrom": */ 0,
                /* "buldingLifeTo": */  0,
                /* "adsDateTimeFrom": */ null,
                /* "adsDateTimeTo": */ null,
               /*  "parking": */ null,
                /* "basement": */ null,
                /* "elevator": */ null,
               /*  "searchQuery": *//*  props.isSearch ? props.searchValue : "" */searchValue ?? "",

        )
        getDetailMasterByQueryNew(
                /* "page": */ page,
                /* "adsMainCategoryCode":  */ 0,
                /* "userCode": */ 0,
                /* "adsAdvertiseTypeCode": */ null,
                /* "adsPrptyTradeTypeCode": */[],
                /* "adsPrptyTypeCode": */[],
                /* "userTypeCode": */[],
                /* "countryCode": */ 1,
                /* "stateCode": */ 2,
                /* "cityCode": */ 3,
                /* "areaCode": */[],
                /* "priceFrom": */ 0,
                /* "priceTo": */ 0,
                /* "depositFrom":  */ 0,
                /* "depositTo": */ 0,
                /* "rentFrom": */ 0,
                /* "rentTo":  */ 0,
                /* "meterageFrom": */ 0,
                /* "meterageTo": */ 0,
                /* "buldingLifeFrom": */ 0,
                /* "buldingLifeTo": */ 0,
                /* "adsDateTimeFrom": */ null,
                /* "adsDateTimeTo": */ null,
                /* "parking": */ null,
                /* "basement": */ null,
                /* "elevator": */ null,
                /* "searchQuery": */ searchValue
        );

        // }
    }, [searchValue]);
    useEffect(() => {
        console.log(" GetDetailMasterByQuery 6");

        setLoaderFetch(true)
        setCityState(citiess);
        const adsMainCategoryCode = props.isFilterWithPropertyCode ? Number(props.isFilterWithPropertyCode) : Number(selectedCategoryItem !== 0 ? selectedCategoryItem.id : 0)
        if (adsMainCategoryCode !== 0 || adsMainCategoryCode !== 1) {
            clearAuctionItems()
            setAuctionItems([])
        }
        if (props.userCode) {
            setItems([]);
            axios.post(`${baseUrl}/Advertise/GetDetailMasterByQueryNew`, {
                "page": 0,
                "adsMainCategoryCode": adsMainCategoryCode,
                "userCode": props.userCode ? props.userCode : 0,
                "adsAdvertiseTypeCode": adsAdvertiseTypeCode ? Number(adsAdvertiseTypeCode) : 0,
                "adsPrptyTradeTypeCode":
                    selectedMelkMoameleItem ? [Number(selectedMelkMoameleItem.id)] : [],
                "adsPrptyTypeCode":
                    selectedMelkTypeItem ? [Number(selectedMelkTypeItem.id)] : [],
                "userTypeCode":
                    noeAgahiDahande ? [Number(noeAgahiDahande)] : [],
                "countryCode": 0,
                "stateCode": 0,
                "cityCode": 0,
                "areaCode": selectedAreasIDs[0],
                "priceFrom": priceFrom ? priceFrom : 0,
                "priceTo": priceTo ? priceTo : 0,
                "depositFrom": depositFrom ? depositFrom : 0,
                "depositTo": depositTo ? depositTo : 0,
                "rentFrom": rentFrom ? rentFrom : 0,
                "rentTo": rentTo ? rentTo : 0,
                "meterageFrom": meterageFrom ? meterageFrom : 0,
                "meterageTo": meterageTo ? meterageTo : 0,
                "buldingLifeFrom": buldingLifeFrom ? buldingLifeFrom : 0,
                "buldingLifeTo": buldingLifeTo ? buldingLifeTo : 0,
                "adsDateTimeFrom": null,
                "adsDateTimeTo": null,
                "parking": parking,
                "basement": basement,
                "elevator": elevator,
                "searchQuery": /* props.isSearch ? props.searchValue : "" */localStorage?.getItem("searchValue"),
                // (localStorage.getItem("veeuAuthData") == props.userCode) &&
            }, (localStorage.getItem("veeuAuthData") == props.userCode) && {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                },
            }
            )
                .then(async (res) => {
                    if (res.data.length) {
                        setIsFetchData(true)

                        setItems(res.data);
                        // setItems([...items, ...res.data]);
                        console.log("injam");

                        setPage(page + 20);
                    }
                    else {
                        setHasMore(false)
                    }
                    if (props?.isInProfilePage && !res.data.length) setLoaderFetch(false)
                })
        } else {
            if (!checkLoadData) {
                // setCheckLoadData(true)
                console.log(" GetDetailMasterByQuery 7");
                (!props.isSearch && (adsMainCategoryCode == 0 || adsMainCategoryCode == 1)) &&


                    getAuctionDetailMasterByQuery(

                    /* "page": */ 0,
                    /* "adsMainCategoryCode": */ adsMainCategoryCode,
                    /* "userCode":  */props.userCode ? props.userCode : 0,
                   /*  "adsAdvertiseTypeCode": */ adsAdvertiseTypeCode ? Number(adsAdvertiseTypeCode) : 0,
                    /* "adsPrptyTradeTypeCode": */selectedMelkMoameleItem ? [Number(selectedMelkMoameleItem.id)] : [],
                    /* "adsPrptyTypeCode":  */selectedMelkTypeItem ? [Number(selectedMelkTypeItem.id)] : [],
                   /*  "userTypeCode": */ noeAgahiDahande ? [Number(noeAgahiDahande)] : [],
                   /*  "countryCode": */ 1,
                    /* "stateCode": */2,
                   /*  "cityCode": */ 3,
                   /*  "areaCode": */ selectedAreasIDs[0],
                    /* "priceFrom": */ priceFrom ? priceFrom : 0,
                   /*  "priceTo": */ priceTo ? priceTo : 0,
                    /* "depositFrom": */ depositFrom ? depositFrom : 0,
                    /* "depositTo":  */depositTo ? depositTo : 0,
                   /*  "rentFrom": */ rentFrom ? rentFrom : 0,
                    /* "rentTo": */ rentTo ? rentTo : 0,
                    /* "meterageFrom": */ meterageFrom ? meterageFrom : 0,
                    /* "meterageTo": */ meterageTo ? meterageTo : 0,
                    /* "buldingLifeFrom": */ buldingLifeFrom ? buldingLifeFrom : 0,
                    /* "buldingLifeTo": */ buldingLifeTo ? buldingLifeTo : 0,
                    /* "adsDateTimeFrom": */ null,
                    /* "adsDateTimeTo": */ null,
                   /*  "parking": */ parking,
                    /* "basement": */ basement,
                    /* "elevator": */ elevator,
                   /*  "searchQuery": */ /* props.isSearch ? props.searchValue : "" */searchValue
                    )

                axios.post(`${baseUrl}/Advertise/GetDetailMasterByQueryNew`, {
                    "page": storeItems.length !== 0 ? Number(localStorage.getItem("page")) : 0,
                    "adsMainCategoryCode": adsMainCategoryCode,
                    "userCode": props.userCode ? props.userCode : 0,
                    "adsAdvertiseTypeCode": adsAdvertiseTypeCode ? Number(adsAdvertiseTypeCode) : 0,
                    "adsPrptyTradeTypeCode": selectedMelkMoameleItem ? [Number(selectedMelkMoameleItem.id)] : [],
                    "adsPrptyTypeCode": selectedMelkTypeItem ? [Number(selectedMelkTypeItem.id)] : [],
                    "userTypeCode": noeAgahiDahande ? [Number(noeAgahiDahande)] : [],
                    "countryCode": 0,
                    "stateCode": 0,
                    "cityCode": 0,
                    "areaCode": selectedAreasIDs[0],
                    "priceFrom": priceFrom ? priceFrom : 0,
                    "priceTo": priceTo ? priceTo : 0,
                    "depositFrom": depositFrom ? depositFrom : 0,
                    "depositTo": depositTo ? depositTo : 0,
                    "rentFrom": rentFrom ? rentFrom : 0,
                    "rentTo": rentTo ? rentTo : 0,
                    "meterageFrom": meterageFrom ? meterageFrom : 0,
                    "meterageTo": meterageTo ? meterageTo : 0,
                    "buldingLifeFrom": buldingLifeFrom ? buldingLifeFrom : 0,
                    "buldingLifeTo": buldingLifeTo ? buldingLifeTo : 0,
                    "adsDateTimeFrom": null,
                    "adsDateTimeTo": null,
                    "parking": parking,
                    "basement": basement,
                    "elevator": elevator,
                    "searchQuery": /* props.searchValue */localStorage?.getItem("searchValue"),
                },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("veeuToken")}`
                        },
                    })
                    .then((res) => {
                        // setIsFetchData(true)
                        setLoaderFetch(false)
                        if (res.data.length < 20) {
                            setItems(res.data);
                            setHasMore(false)
                            setIsFetchData(true)
                        } else {
                            console.log("injam2");
                            setPage(page + 20);
                            setItems(res.data);
                            setIsFetchData(true)
                            localStorage.setItem("page", Number(localStorage.getItem("page")) + 20)
                        }
                    })
            }
        }
    }, [
        selectedCategoryItem,
        selectedMelkTypeItem, selectedMelkMoameleItem, props.isFilterWithPropertyCode,
        parking && parking,
        basement && basement,
        elevator && elevator,
        isFilterPrice && priceFrom, isFilterPrice && priceTo,
        selectedAreas, moveToSelectArea, adsAdvertiseTypeCode, noeAgahiDahande, selectedAreasIDs])

    // useEffect(() => {
    //     setLoaderFetch(true)
    //     setCityState(citiess);
    //     if (!checkLoadData) {
    //         // setCheckLoadData(true)
    //         (!props.isSearch && !props.userCode) &&
    //             axios.post(`${baseUrl}/Advertise/GetDetailMasterByQueryNew`, {
    //                 "page": storeItems.length !== 0 ? Number(localStorage.getItem("page")) : 0,
    //                 "adsMainCategoryCode": props.isFilterWithPropertyCode ? Number(props.isFilterWithPropertyCode) : Number(selectedCategoryItem !== 0 ? selectedCategoryItem.id : 0),
    //                 "userCode": props.userCode ? props.userCode : 0,
    //                 "adsAdvertiseTypeCode": adsAdvertiseTypeCode ? Number(adsAdvertiseTypeCode) : 0,
    //                 "adsPrptyTradeTypeCode": [
    //                     selectedMelkMoameleItem ? Number(selectedMelkMoameleItem.id) : 0
    //                 ],
    //                 "adsPrptyTypeCode": [
    //                     selectedMelkTypeItem ? Number(selectedMelkTypeItem.id) : 0
    //                 ],
    //                 "userTypeCode": [
    //                     noeAgahiDahande ? Number(noeAgahiDahande) : 0
    //                 ],
    //                 "countryCode": 0,
    //                 "stateCode": 0,
    //                 "cityCode": 0,
    //                 "areaCode": selectedAreasIDs[0],
    //                 "priceFrom": priceFrom ? priceFrom : 0,
    //                 "priceTo": priceTo ? priceTo : 0,
    //                 "depositFrom": depositFrom ? depositFrom : 0,
    //                 "depositTo": depositTo ? depositTo : 0,
    //                 "rentFrom": rentFrom ? rentFrom : 0,
    //                 "rentTo": rentTo ? rentTo : 0,
    //                 "meterageFrom": meterageFrom ? meterageFrom : 0,
    //                 "meterageTo": meterageTo ? meterageTo : 0,
    //                 "buldingLifeFrom": buldingLifeFrom ? buldingLifeFrom : 0,
    //                 "buldingLifeTo": buldingLifeTo ? buldingLifeTo : 0,
    //                 "adsDateTimeFrom": null,
    //                 "adsDateTimeTo": null,
    //                 "parking": parking,
    //                 "basement": basement,
    //                 "elevator": elevator,
    //                 "searchQuery": props.searchValue
    //             })
    //                 .then((res) => {
    //                     setLoaderFetch(false)
    //                     if (res.data.length < 20) {
    //                         setItems(res.data);
    //                         setHasMore(false)
    //                         setIsFetchData(true)
    //                     } else {
    //                         setPage(page + 20);
    //                         setItems(res.data);
    //                         setIsFetchData(true)
    //                         localStorage.setItem("page", Number(localStorage.getItem("page")) + 20)
    //                     }
    //                 })
    //     }
    // }, [
    //     selectedCategoryItem,
    //     selectedMelkTypeItem, selectedMelkMoameleItem, props.isFilterWithPropertyCode,
    //     parking && parking,
    //     basement && basement,
    //     elevator && elevator,
    //     isFilterPrice && priceFrom, isFilterPrice && priceTo,
    //     selectedAreas, moveToSelectArea, adsAdvertiseTypeCode, noeAgahiDahande, selectedAreasIDs])

    const clearFilters = () => {
        getDetailMasterByQueryByAllStrings(
                /*"page":*/ page,
            /*"adsMainCategoryCode":*/ Number(selectedCategoryItem !== 0 ? selectedCategoryItem.id : 0),
            /*"userCode":*/ props.userCode ? props.userCode : 0,
            /*"adsAdvertiseTypeCode": */  0,
            /*"adsPrptyTradeTypeCode": */[
                0
            ],
            /*"adsPrptyTypeCode":  */[
                0
            ],
            // "userTypeCode":
            [
                0
            ],
            /* "countryCode":*/ 0,
            /*"stateCode": */ 0,
            /*"cityCode": */ 0,
            /*"areaCode": */[
                0
            ],
            /*"priceFrom" */   0,
            /*"priceTo" */ 0,
             /*"depositFrom" */  0,
            /*"depositTo" */  0,
            /*"rentFrom" */   0,
            /*"rentTo" */   0,
            /*"meterageFrom" */   0,
            /*"meterageTo" */   0,
            /*"buldingLifeFrom" */   0,
            /*"buldingLifeTo" */   0,
            /*"adsDateTimeFrom" */  null,
            /*"adsDateTimeTo" */  null,
            /*"parking" */  parking,
            /*"basement" */  basement,
            /*"elevator" */  elevator
        )
        setIsShowChoseCategoryPage(false)
        setIsShowFilters(false)
        setIsShowChoseMElkTypePage(false)
        setIsShowChoseMoamelePage(false)
        setMoveToSelectArea(false)
        setSelectedCategoryItem(0)
        setSelectedMelkMoameleItem(0)
        setSelectedMelkTypeItem(0)
        setPriceFrom("")
        setPriceTo("")
        setSelectedAreas([])
        // setSelectedAreasName([])
        setNoAgahiDahande("")
    }

    // select areas (find Duplicate == remove area from arry) ||  (find Duplicate != add area to arry)
    function toggleItem(item) {
        let findDuplicateIndex = selectedAreas.find(area => area.id === item.id);
        console.log(findDuplicateIndex, "findDuplicateIndex");

        if (findDuplicateIndex) {
            // setSelectedAreas(selectedAreas.filter(area => area.id != item.id));
            const updatedSelectedAreas = selectedAreas.filter(area => area.id !== item.id);
            setSelectedAreas(updatedSelectedAreas);
            const firstId = updatedSelectedAreas[0]?.id;
            const districts = updatedSelectedAreas?.slice(1).map(area => area.id).join(',');
            const url = districts ? `/${firstId}?districts=${districts}` : `/${firstId || ''}`;
            if (!(props?.isInProfilePage)) navigate(url);
        } else {
            // selectedAreas.push(item);
            // navigate(`/${selectedAreas[0]?.id}`)



            const newSelectedAreas = [...selectedAreas, item];

            setSelectedAreas(newSelectedAreas);
            const firstId = newSelectedAreas[0]?.id;
            const districts = newSelectedAreas?.slice(1).map(area => area.id).join(',');
            console.log(districts, "districts districts");
            console.log(firstId, "firstId firstId");
            const url = districts ? `/${firstId}?districts=${districts}` : `/${firstId}`;
            // navigate(url);
            if (!(props?.isInProfilePage)) navigate(url);
        }
    }

    // search in areas 
    const searchInCitiesHandler = (e) => {
        setSearchInCitiesValue(e.target.value)
        setCityState(citiess.filter(item => item.locName.includes(e.target.value)));
    }


    console.log(items, "items in NewFilter");
    console.log(storeItems, "storeItems in NewFilter");

    // clear filters 
    const showAllAdss = async (__page) => {
        setLoaderFetch(true)
        axios.post(`${baseUrl}/Advertise/GetDetailMasterByQueryNew`, {
            "page": 0,
            "adsMainCategoryCode": 0,
            "userCode": 0,
            "adsAdvertiseTypeCode": 0,
            "adsPrptyTradeTypeCode": [

            ],
            "adsPrptyTypeCode": [

            ],
            "userTypeCode": [

            ],
            "countryCode": 0,
            "stateCode": 0,
            "cityCode": 0,
            "areaCode": selectedAreasIDs[0],
            "priceFrom": 0,
            "priceTo": 0,
            "depositFrom": 0,
            "depositTo": 0,
            "rentFrom": 0,
            "rentTo": 0,
            "meterageFrom": 0,
            "meterageTo": 0,
            "buldingLifeFrom": 0,
            "buldingLifeTo": 0,
            "adsDateTimeFrom": null,
            "adsDateTimeTo": null,
            "parking": null,
            "basement": null,
            "elevator": null,
            "searchQuery": ""
        })
            .then((res) => {
                setLoaderFetch(false)
                if (res.data.length < 20) {
                    setItems(res.data);
                    setHasMore(false)
                    setIsFetchData(true)
                } else {
                    setPage(page + 20);
                    setItems(res.data);
                    setIsFetchData(false)
                    localStorage.setItem("page", Number(localStorage.getItem("page")) + 20)
                }
            })
    };
    const clearPrices = () => {
        // setIsFilterPrice(true)
        setPriceFrom(null)
        setPriceTo(null)
    }


    return (
        <>
            <div className='flex items-center justify-center w-full'>
                <div className="flex items-center border border-[1px] border-gray-500 rounded rounded-lg  w-[97%]">
                    <div onClick={() => setIsShowFilters(true)} className={`flex items-center ml-4`} >
                        <img src="/icons/FilterIcon.svg" className='w-10 h-10 p-1 filterIcon cursor-pointer' alt="" />
                        <p>فیلترها</p>
                    </div>
                    <div className="flex flex-row w-full overflow-x-scroll scroll-filter ">
                        {selectedCategoryItem != 0 ? (
                            <div onClick={async () => {
                                setSelectedCategoryItem(0)
                                setSelectedMelkTypeItem(0)
                                setSelectedMelkMoameleItem(0)
                                filter()
                                setRemovedCategoryFromFilter(true)
                                
                            }} className="cursor-poiner rounded-xl border border-[#494949] m-1 px-3 py-1 text-[#494949] flex items-center min-w-fit">
                                <img src="/icons/new-red-close.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">{selectedCategoryItem.title}</p>
                            </div>
                        ) : ""}

                        {propertyCodeName != "" && (
                            <div className="rounded-xl border border-[#494949] m-1 px-3 py-1 text-[#494949] flex items-center opacity-50 min-w-fit">
                                <img src="/icons/new-red-close.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">{propertyCodeName}</p>
                            </div>
                        )}
                        {selectedMelkTypeItem != 0 && (
                            <div onClick={async () => {
                                setSelectedMelkTypeItem(0)
                                setSelectedMelkMoameleItem(0)
                                filter()
                            }} className="rounded-xl border border-[#494949] m-1 px-3 py-1 text-[#494949] flex items-center  min-w-fit">
                                <img src="/icons/new-red-close.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">{selectedMelkTypeItem.title}</p>
                            </div>
                        )}
                        {selectedMelkMoameleItem != 0 && (
                            <div onClick={async () => {
                                setSelectedMelkMoameleItem(0)
                                filter()
                            }} className="rounded-xl border border-[#494949] m-1 px-3 py-1 text-[#494949] flex items-center  min-w-fit">
                                <img src="/icons/new-red-close.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">{selectedMelkMoameleItem.title}</p>
                            </div>
                        )}
                        {(priceFrom || priceTo) && (
                            <div onClick={async () => {
                                setIsFilterPrice(true)
                                clearPrices()

                            }} className="rounded border border-red-500 m-1 px-1 text-red-600 flex items-center min-w-fit">
                                <img src="/icons/close-red.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">قیمت</p>
                            </div>
                        )}
                        {selectedAreas.length ? (
                            <div onClick={async () => {
                                setSelectedAreas([])
                                setSelectedAreasIDs([])
                                setIsShowPrice(false)
                                filter()
                            }} className="rounded-xl border border-[#494949] m-1 px-3 py-1 text-[#494949] flex items-center min-w-fit">
                                <img src="/icons/new-red-close.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">محله  </p>
                            </div>
                        ) : ""}

                        {adsAdvertiseTypeCode != "" ? (
                            <div onClick={async () => {
                                setAdsAdvertiseTypeCode(0)
                                filter()
                            }} className="rounded-xl border border-[#494949] m-1 px-3 py-1 text-[#494949] flex items-center min-w-fit">
                                <img src="/icons/new-red-close.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">
                                    {adsAdvertiseTypeCode == 1 && "عادی"}
                                    {adsAdvertiseTypeCode == 2 && "حراجی"}
                                    {adsAdvertiseTypeCode == 3 && "همه"}
                                </p>
                            </div>
                        ) : ""}
                        {noeAgahiDahande != "" ? (
                            <div onClick={async () => {
                                setNoAgahiDahande(0)
                                filter()
                            }} className="rounded-xl border border-[#494949] m-1 px-3 py-1 text-[#494949] flex items-center min-w-fit">
                                <img src="/icons/new-red-close.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">
                                    {noeAgahiDahande == 1 && "شخصی"}
                                    {noeAgahiDahande == 2 && "تجاری"}
                                    {noeAgahiDahande == 3 && "همه"}
                                </p>
                            </div>
                        ) : ""}
                        {parking ? (
                            <div onClick={async () => {
                                setParking(false)
                                // filter()
                            }} className="rounded-xl border border-[#494949] m-1 px-3 py-1 text-[#494949] flex items-center min-w-fit">
                                <img src="/icons/new-red-close.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">پارکینگ</p>
                            </div>
                        ) : ""}
                        {basement ? (
                            <div onClick={async () => {
                                setbasement(false)
                                // filter()
                            }} className="rounded-xl border border-[#494949] m-1 px-3 py-1 text-[#494949] flex items-center min-w-fit">
                                <img src="/icons/new-red-close.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">انباری</p>
                            </div>
                        ) : ""}
                        {elevator ? (
                            <div onClick={async () => {
                                setElevator(false)
                                // filter()
                            }} className="rounded-xl border border-[#494949] m-1 px-3 py-1 text-[#494949] flex items-center min-w-fit">
                                <img src="/icons/new-red-close.svg" alt="حذف" />
                                <p className="text-sm text-nowrap">آسانسور</p>
                            </div>
                        ) : ""}
                    </div>
                </div>
            </div>
            <div className="w-full flex justify-center mt-2 ">{renderImage()}</div>
            {/*  */}
            <div onClick={(e) => {
                if (e.target.className.includes("style-for-close-on-outside-filter")) {
                    document.removeEventListener("click", setIsShowFilters(false));
                }
            }} className={`sm:p-0 select-none pt-4 fixed style-for-close-on-outside-filter top-0 w-full
              h-screen bg-[#8d8d8da1] transition-all z-40 duration-500 ${isShowFilters ? "left-0" : "left-[10000px]"} "}`}>
                <div className="sm:w-full md:w-full w-[60%] relative h-dvh z-50 bg-white">
                    <div className="border-b borer-b-2">
                        <div className="flex items-center justify-between  px-8  py-4">
                            <p className="font-bold">فیلترآگهی ها</p>
                            <button onClick={() => clearFilters()} className="border border-red-600 text-red-600 px-4 py-1 rounded">
                                پاکسازی فیلترها
                            </button>
                        </div>
                    </div>
                    <div >
                        <div onClick={() => { setIsShowChoseCategoryPage(true) }}
                            className={`px-6  py-2 ${props.isFilterWithPropertyCode ? "select-none opacity-50" : "opacity-100 select-auto"}`}>
                            <div className="flex items-center w-full justify-between py-2 ">
                                <div className="flex items-center gap-1">
                                    <p>دسته بندی</p>
                                    <p className="font-bold">{selectedCategoryItem != 0 ? selectedCategoryItem.title : propertyCodeName}</p>
                                </div>
                                <img src="/icons/arrow-b-f.svg" alt="go" />
                            </div>
                            <div className="w-full h-[1px] bg-gray-200"></div>
                        </div>
                        <div className={`absolute bg-white w-full  screen top-[4rem] z-40 ${(isShowChoseCategoryPage && !props.isFilterWithPropertyCode) ? "left-0 " : "left-[10000px]"}`}>
                            <div className="px-6 w-full  ">
                                {
                                    ADS_MainCategoryCode.map(sub => (
                                        <div onClick={() => {
                                            setSelectedCategoryItem(sub)
                                            if (sub.id == 1) {
                                                setIsShowChoseMoamelePage(true)
                                            } else {
                                                setIsShowChoseCategoryPage(false)
                                            }
                                        }} key={sub.id} className="cursor-pointer flex items-center justify-between border-b py-4" >
                                            <p>{sub.title}</p>
                                            <img src="/icons/arrow-b-f.svg" alt="go" />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        <div className={`absolute bg-white w-full h-screen top-[4rem] z-50 ${isShowChoseMElkTypePage ? "left-0 " : "left-[10000px]"}`}>
                            <div className="px-6 w-full ">
                                انتخاب نوع ملک
                                {
                                    selectedMelkMoameleItem.id == 6 ? (
                                        ADS_PropertyTypeCode.slice(0, 4).map(sub => (
                                            <div onClick={() => {
                                                setSelectedMelkTypeItem(sub)
                                                setIsShowChoseMoamelePage(false)
                                                setIsShowChoseMElkTypePage(false)
                                            }} key={sub.id} className="cursor-pointer flex items-center justify-between border-b py-4" >
                                                <p>{sub.title}</p>
                                                <img src="/icons/arrow-b-f.svg" alt="go" />
                                            </div>
                                        ))
                                    ) :
                                        (
                                            ADS_PropertyTypeCode.map(sub => (
                                                <div onClick={() => {
                                                    setSelectedMelkTypeItem(sub)
                                                    setIsShowChoseMoamelePage(false)
                                                    setIsShowChoseMElkTypePage(false)
                                                }} key={sub.id} className="cursor-pointer flex items-center justify-between border-b py-4" >
                                                    <p>{sub.title}</p>
                                                    <img src="/icons/arrow-b-f.svg" alt="go" />
                                                </div>
                                            ))
                                        )
                                }
                            </div>
                        </div>
                        <div className={`pt-4 sm:pt-0 absolute bg-white w-full h-screen top-[4rem] z-50 ${isShowChoseMoamelePage ? "left-0 " : "left-[10000px]"}`}>
                            <div className="px-6 w-full ">
                                انتخاب نوع معامله
                                {
                                    ADS_PropertyTradeTypeCode.map(sub => (
                                        <div onClick={() => {
                                            setSelectedMelkMoameleItem(sub)
                                            setIsShowChoseCategoryPage(false)
                                            setIsShowChoseMoamelePage(false)
                                            if (sub.id !== 0) {
                                                setIsShowChoseMElkTypePage(true)
                                            } else {
                                                setIsShowChoseMElkTypePage(false)
                                            }
                                        }} key={sub.id} className=" cursor-pointer flex items-center justify-between border-b py-4" >
                                            <p>{sub.title}</p>
                                            <img src="/icons/arrow-b-f.svg" alt="go" />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className={`px-6 `}>
                            <div onClick={() => setMoveToSelectArea(true)} className="flex items-center w-full justify-between  ">
                                <p className="py-2">محله</p>
                                <img src="/icons/arrow-b-f.svg" alt="go" />
                            </div>
                            <div className="w-full h-[1px] bg-gray-200"></div>
                            <div className="flex overflow-scroll gap-2 scroll-filter ">
                                {
                                    selectedAreas.length > 0 && selectedAreas.map(item => (
                                        <div
                                            onClick={async () => {
                                                setSelectedAreas(selectedAreas.filter(finallyArea => item.id != finallyArea.id))
                                                console.log(selectedAreas, "selectedAreas 78787878")
                                            }}
                                            className="cursor-pointer rounded-xl border border-[#494949] m-1 px-3 py-1 text-[#494949] flex items-center gap-1 w-max ">
                                            <p className="text-sm text-nowrap">{item.locName}</p>
                                            <img src="/icons/new-red-close.svg" alt="حذف" />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>

                    {
                        selectedMelkMoameleItem !== 0 && (
                            <>
                                {
                                    selectedMelkMoameleItem && (selectedMelkMoameleItem.id == 6) && (
                                        <>
                                            <div className="px-6  py-2">
                                                <div onClick={() => {
                                                    setIsShowLife(false)
                                                    setIsShowRentPerMonth(false)
                                                    setIsShowDailyPrice(!isShowDailyPrice)
                                                    setIsDeposit(false)
                                                    setIsShowLife(false)
                                                    setIsShowOptions(false)
                                                    setIsShowAdsDahande(false)
                                                    setType(false)
                                                }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                    <p>اجاره روزانه</p>
                                                    <img className={`transition-all ${isShowDailyPrice ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                </div>
                                                {
                                                    isShowDailyPrice ? (
                                                        <>
                                                            <div className="mb-2 flex flex-col">
                                                                <div className="flex items-center gap-2">
                                                                    <span>از</span>
                                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                        <input
                                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                            value={dailyPriceFrom}
                                                                            onChange={(e) => setDailyPriceFrom(e.target.value)}
                                                                            pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                            type="tel"

                                                                        />
                                                                        <span className="p-1 border-r">تومان</span>
                                                                    </div>
                                                                </div>
                                                                {/* {dailyPriceFrom ? (<p className='px-5 text-[12px] text-green-600 py-1'>{(Num2persian(dailyPriceFrom))}</p>) : null} */}
                                                            </div>
                                                            <div className="mb-2 flex flex-col">
                                                                <div className="flex items-center gap-2">
                                                                    <span>تا</span>
                                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                        <input
                                                                            value={dailyPriceTo}
                                                                            onChange={(e) => setDailyPriceTo(e.target.value)}
                                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                            pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                            type="tel"

                                                                        />
                                                                        <span className="p-1 border-r">تومان</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : ""
                                                }
                                                <div className="w-full h-[1px] bg-gray-200"></div>
                                            </div>

                                            <div className="px-6  py-2">
                                                <div onClick={() => {
                                                    setIsShowLife(false)
                                                    setIsShowRentPerMonth(false)
                                                    setIsShowMetrage(!isShowMetrage)
                                                    setIsDeposit(false)
                                                    setIsShowLife(false)
                                                    setIsShowOptions(false)
                                                    setIsShowAdsDahande(false)
                                                    setType(false)
                                                    setIsShowDailyPrice(false)
                                                }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                    <p>متراژ</p>
                                                    <img className={`transition-all ${isShowMetrage ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                </div>
                                                {
                                                    isShowMetrage ? (
                                                        <>
                                                            <div className="mb-2 flex flex-col">
                                                                <div className="flex items-center gap-2">
                                                                    <span>از</span>
                                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                        <input
                                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                            value={meterageFrom}
                                                                            onChange={(e) => setMeterageFrom(e.target.value)}
                                                                            pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                            type="tel"
                                                                            maxLength={4}
                                                                        />
                                                                        <span className="p-1 border-r">متر</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="mb-2 flex flex-col">
                                                                <div className="flex items-center gap-2">
                                                                    <span>تا</span>
                                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                        <input
                                                                            value={meterageTo}
                                                                            onChange={(e) => setMeterageTo(e.target.value)}
                                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                            pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                            type="tel"
                                                                            maxLength={4}
                                                                        />
                                                                        <span className="p-1 border-r">متر</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : ""
                                                }
                                                <div className="w-full h-[1px] bg-gray-200"></div>
                                            </div>

                                            <div className="px-6  py-2">
                                                <div onClick={() => {
                                                    setIsShowOptions(!isShowOptions)
                                                    setIsShowLife(false)
                                                    setIsShowMetrage(false)
                                                    setIsShowRentPerMonth(false)
                                                    setIsDeposit(false)
                                                    setIsShowAdsDahande(false)
                                                    setType(false)
                                                }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                    <p>امکانات</p>
                                                    <img className={`transition-all ${isShowOptions ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                </div>
                                                <div className="flex flex-col gap-2 mb-2">
                                                    {
                                                        isShowOptions ? (
                                                            <div className="flex items-center justify-between">
                                                                <div onClick={() => setParking(!parking)} className="flex items-center gap-2">
                                                                    <input id="all" type="checkbox" />
                                                                    <label htmlFor="all">پارکینگ</label>
                                                                </div>
                                                                <div onClick={() => setbasement(!basement)} className="flex items-center gap-2">
                                                                    <input id="all" type="checkbox" />
                                                                    <label htmlFor="all">انباری</label>
                                                                </div>
                                                                <div onClick={() => setElevator(!elevator)} className="flex items-center gap-2">
                                                                    <input id="all" type="checkbox" />
                                                                    <label htmlFor="all">آسانسور</label>
                                                                </div>
                                                            </div>
                                                        ) : ""
                                                    }
                                                </div>
                                                <div className="w-full h-[1px] bg-gray-200"></div>
                                            </div>
                                        </>
                                    )
                                }
                                {
                                    selectedMelkMoameleItem && (selectedMelkMoameleItem.id == 4) ? (
                                        <>
                                            <div className="px-6  py-2">
                                                <div onClick={() => {
                                                    setIsShowLife(false)
                                                    setIsShowRentPerMonth(false)
                                                    setIsShowMetrage(!isShowMetrage)
                                                    setIsDeposit(false)
                                                    setIsShowLife(false)
                                                    setIsShowOptions(false)
                                                    setIsShowAdsDahande(false)
                                                    setType(false)
                                                    setIsShowDailyPrice(false)
                                                }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                    <p>متراژ</p>
                                                    <img className={`transition-all ${isShowMetrage ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                </div>
                                                {
                                                    isShowMetrage ? (
                                                        <>
                                                            <div className="mb-2 flex flex-col">
                                                                <div className="flex items-center gap-2">
                                                                    <span>از</span>
                                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                        <input
                                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                            value={meterageFrom}
                                                                            onChange={(e) => setMeterageFrom(e.target.value)}
                                                                            pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                            type="tel"
                                                                            maxLength={4}
                                                                        />
                                                                        <span className="p-1 border-r">متر</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="mb-2 flex flex-col">
                                                                <div className="flex items-center gap-2">
                                                                    <span>تا</span>
                                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                        <input
                                                                            value={meterageTo}
                                                                            onChange={(e) => setMeterageTo(e.target.value)}
                                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                            pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                            type="tel"
                                                                            maxLength={4}
                                                                        />
                                                                        <span className="p-1 border-r">متر</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : ""
                                                }
                                                <div className="w-full h-[1px] bg-gray-200"></div>
                                            </div>
                                        </>
                                    ) : (
                                        selectedMelkMoameleItem && (selectedMelkMoameleItem.id == 2) ? (<>
                                            <div className="px-6  py-2">
                                                <div onClick={() => {
                                                    setIsDeposit(!isShowDeposit)
                                                    setIsShowRentPerMonth(false)
                                                    setIsShowLife(false)
                                                    setIsShowMetrage(false)
                                                    setIsShowOptions(false)
                                                    setIsShowAdsDahande(false)
                                                    setType(false)
                                                }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                    <p>
                                                        ودیعه
                                                    </p>
                                                    <img className={`transition-all ${isShowDeposit ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                </div>
                                                {
                                                    isShowDeposit ? (
                                                        <>
                                                            <div className="mb-2 flex flex-col">
                                                                <div className="flex items-center gap-2">
                                                                    <span>از</span>
                                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                        <input
                                                                            value={depositFrom}
                                                                            onChange={(e) => setDepositFrom(e.target.value)}
                                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                            pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                            type="tel"
                                                                        />
                                                                        <span className="p-1 border-r">تومان</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="mb-2 flex flex-col">
                                                                <div className="flex items-center gap-2">
                                                                    <span>تا</span>
                                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                        <input
                                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                            value={depositTo}
                                                                            onChange={(e) => setDepositTo(e.target.value)}
                                                                            pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                            type="tel"
                                                                            maxLength={19}
                                                                        />
                                                                        <span className="p-1 border-r">تومان</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : ""
                                                }
                                                <div className="w-full h-[1px] bg-gray-200"></div>
                                            </div>
                                            <div className="px-6  py-2">
                                                <div onClick={() => {
                                                    setIsShowRentPerMonth(!isShowRentPerMonth)
                                                    setIsDeposit(false)
                                                    setIsShowLife(false)
                                                    setIsShowMetrage(false)
                                                    setIsShowOptions(false)
                                                    setIsShowAdsDahande(false)
                                                    setType(false)
                                                }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                    <p>
                                                        اجاره
                                                    </p>
                                                    <img className={`transition-all ${isShowRentPerMonth ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                </div>
                                                {
                                                    isShowRentPerMonth ? (
                                                        <>
                                                            <div className="mb-2 flex flex-col">
                                                                <div className="flex items-center gap-2">
                                                                    <span>از</span>
                                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                        <input
                                                                            value={rentFrom}
                                                                            onChange={(e) => setRentFrom(e.target.value)}
                                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                            pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                            maxLength={19}
                                                                        />
                                                                        <span className="p-1 border-r">تومان</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="mb-2 flex flex-col">
                                                                <div className="flex items-center gap-2">
                                                                    <span>تا</span>
                                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                        <input
                                                                            value={rentTo}
                                                                            onChange={(e) => setRentTo(e.target.value)}
                                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                            pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                            type="tel"
                                                                            maxLength={19}
                                                                        />
                                                                        <span className="p-1 border-r">تومان</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : ""
                                                }
                                                <div className="w-full h-[1px] bg-gray-200"></div>
                                            </div>
                                        </>) : (<>
                                            {
                                                selectedMelkMoameleItem && (selectedMelkMoameleItem.id != 6) && (
                                                    <>
                                                        <div className="px-6  py-2">
                                                            <div onClick={() => {
                                                                setIsShowPricePerMeter(!isShowPricePerMeter)
                                                            }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                                <p>
                                                                    قیمت متری
                                                                </p>
                                                                <img className={`transition-all ${isShowPricePerMeter ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                            </div>
                                                            {
                                                                isShowPricePerMeter ? (
                                                                    <>
                                                                        <div className="mb-2 flex flex-col">
                                                                            <div className="flex items-center gap-2">
                                                                                <span>از</span>
                                                                                <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                                    <input
                                                                                        className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                        value={pricePerMeterFrom}
                                                                                        onChange={(e) => setPricePerMeterFrom(e.target.value)}
                                                                                        pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                        type="tel"
                                                                                        maxLength={19}
                                                                                    />
                                                                                    <span className="p-1 border-r">تومان</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-2 flex flex-col">
                                                                            <div className="flex items-center gap-2">
                                                                                <span>تا</span>
                                                                                <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                                    <input
                                                                                        className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                        value={pricePerMeterTo}
                                                                                        onChange={(e) => setPricePerMeterTo(e.target.value)}
                                                                                        pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                        type="tel"
                                                                                        maxLength={19}
                                                                                    />
                                                                                    <span className="p-1 border-r">تومان</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                ) : ""
                                                            }
                                                            <div className="w-full h-[1px] bg-gray-200"></div>
                                                        </div>
                                                        <div className="px-6  py-2">
                                                            <div onClick={() => {
                                                                setIsShowPriceTotal(!isShowPriceTotal)
                                                            }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                                <p>
                                                                    قیمت کل
                                                                </p>
                                                                <img className={`transition-all ${isShowPriceTotal ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                            </div>
                                                            {
                                                                isShowPriceTotal ? (
                                                                    <>
                                                                        <div className="mb-2 flex flex-col">
                                                                            <div className="flex items-center gap-2">
                                                                                <span>از</span>
                                                                                <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                                    <input
                                                                                        className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                        value={priceTotalFrom}
                                                                                        onChange={(e) => setPriceTotalFrom(e.target.value)}
                                                                                        pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                        type="tel"
                                                                                        maxLength={19}
                                                                                    />
                                                                                    <span className="p-1 border-r">تومان</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-2 flex flex-col">
                                                                            <div className="flex items-center gap-2">
                                                                                <span>تا</span>
                                                                                <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                                    <input
                                                                                        className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                                        value={priceTotalTo}
                                                                                        onChange={(e) => setPriceTotalTo(e.target.value)}
                                                                                        pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                                        type="tel"
                                                                                        maxLength={19}
                                                                                    />
                                                                                    <span className="p-1 border-r">تومان</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                ) : ""
                                                            }
                                                            <div className="w-full h-[1px] bg-gray-200"></div>
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </>)
                                    )
                                }

                                {
                                    selectedMelkMoameleItem && (selectedMelkMoameleItem.id != 4) && (selectedMelkMoameleItem.id != 6) && (
                                        <>
                                            <div className="px-6  py-2">
                                                <div onClick={() => {
                                                    setIsShowLife(false)
                                                    setIsShowRentPerMonth(false)
                                                    setIsShowMetrage(!isShowMetrage)
                                                    setIsDeposit(false)
                                                    setIsShowLife(false)
                                                    setIsShowOptions(false)
                                                    setIsShowAdsDahande(false)
                                                    setType(false)
                                                    setIsShowDailyPrice(false)
                                                }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                    <p>متراژ</p>
                                                    <img className={`transition-all ${isShowMetrage ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                </div>
                                                {
                                                    isShowMetrage ? (
                                                        <>
                                                            <div className="mb-2 flex flex-col">
                                                                <div className="flex items-center gap-2">
                                                                    <span>از</span>
                                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                        <input
                                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                            value={meterageFrom}
                                                                            onChange={(e) => setMeterageFrom(e.target.value)}
                                                                            pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                            type="tel"
                                                                            maxLength={4}
                                                                        />
                                                                        <span className="p-1 border-r">متر</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="mb-2 flex flex-col">
                                                                <div className="flex items-center gap-2">
                                                                    <span>تا</span>
                                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                        <input
                                                                            value={meterageTo}
                                                                            onChange={(e) => setMeterageTo(e.target.value)}
                                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                            pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                            type="tel"

                                                                        />
                                                                        <span className="p-1 border-r">متر</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : ""
                                                }
                                                <div className="w-full h-[1px] bg-gray-200"></div>
                                            </div>
                                            <div className="px-6  py-2">
                                                <div onClick={() => {
                                                    setIsShowMetrage(false)
                                                    setIsShowLife(!isShowLife)
                                                    setIsShowRentPerMonth(false)
                                                    setIsDeposit(false)
                                                    setIsShowOptions(false)
                                                    setIsShowAdsDahande(false)
                                                    setType(false)
                                                }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                    <p>عمر بنا</p>
                                                    <img className={`transition-all ${isShowLife ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                </div>
                                                {
                                                    isShowLife ? (
                                                        <>
                                                            <div className="mb-2 flex flex-col">
                                                                <div className="flex items-center gap-2">
                                                                    <span>از</span>
                                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                        <input
                                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                            pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                            type="tel"
                                                                            value={buldingLifeFrom}
                                                                            onChange={(e) => setBuldingLifeFrom(e.target.value)}
                                                                        />
                                                                        <span className="p-1 border-r">سال</span>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div className="mb-2 flex flex-col">
                                                                <div className="flex items-center gap-2">
                                                                    <span>تا</span>
                                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                                        <input
                                                                            value={buldingLifeTo}
                                                                            onChange={(e) => setBuldingLifeTo(e.target.value)}
                                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                                            pattern='[0-9۰-۹آ-ی‌ ‍٬]*'
                                                                            type="tel"

                                                                        />
                                                                        <span className="p-1 border-r">سال</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : ""
                                                }
                                                <div className="w-full h-[1px] bg-gray-200"></div>
                                            </div>
                                            <div className="px-6  py-2">
                                                <div onClick={() => {
                                                    setIsShowOptions(!isShowOptions)
                                                    setIsShowLife(false)
                                                    setIsShowMetrage(false)
                                                    setIsShowRentPerMonth(false)
                                                    setIsDeposit(false)
                                                    setIsShowAdsDahande(false)
                                                    setType(false)
                                                }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                                    <p>امکانات</p>
                                                    <img className={`transition-all ${isShowOptions ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                                </div>
                                                <div className="flex flex-col gap-2 mb-2">
                                                    {
                                                        isShowOptions ? (
                                                            <div className="flex items-center justify-between">
                                                                <div onClick={() => setParking(!parking)} className="flex items-center gap-2">
                                                                    <input id="all" type="checkbox" />
                                                                    <label htmlFor="all">پارکینگ</label>
                                                                </div>
                                                                <div onClick={() => setbasement(!basement)} className="flex items-center gap-2">
                                                                    <input id="all" type="checkbox" />
                                                                    <label htmlFor="all">انباری</label>
                                                                </div>
                                                                <div onClick={() => setElevator(!elevator)} className="flex items-center gap-2">
                                                                    <input id="all" type="checkbox" />
                                                                    <label htmlFor="all">آسانسور</label>
                                                                </div>
                                                            </div>
                                                        ) : ""
                                                    }
                                                </div>
                                                <div className="w-full h-[1px] bg-gray-200"></div>
                                            </div>
                                        </>
                                    )
                                }

                            </>
                        )
                    }
                    {
                        !props.userCode && (
                            <div className="px-6  py-2">
                                <div onClick={() => {
                                    setIsShowOptions(false)
                                    setIsShowAdsDahande(!isShowTypeAdsDahande)
                                    setIsShowLife(false)
                                    setIsShowMetrage(false)
                                    setIsShowRentPerMonth(false)
                                    setIsDeposit(false)
                                    setType(false)
                                }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                    <p>نوع آگهی دهنده</p>
                                    <img className={`transition-all ${isShowTypeAdsDahande ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                </div>
                                {
                                    isShowTypeAdsDahande ? (
                                        <>
                                            <div className="flex justify-between gap-2 mb-2">
                                                <div onClick={() => setNoAgahiDahande(noeAgahiDahande == 0 ? null : 0)} className="flex items-center gap-2">
                                                    <input checked={noeAgahiDahande == 0 && true} id="all" type="checkbox" defaultChecked={noeAgahiDahande == 0 ? true : false} />
                                                    <label htmlFor="all" >همه</label>
                                                </div>
                                                <div onClick={() => setNoAgahiDahande(2)} className="flex items-center gap-2">
                                                    <input checked={noeAgahiDahande == 0 ? true : noeAgahiDahande == 2 && true} id="busi" type="checkbox" />
                                                    <label htmlFor="busi">تجاری</label>
                                                </div>
                                                <div onClick={() => setNoAgahiDahande(1)} className="flex items-center gap-2">
                                                    <input checked={noeAgahiDahande == 0 ? true : noeAgahiDahande == 1 && true} id="personal" type="checkbox" />
                                                    <label htmlFor="personal">شخصی</label>
                                                </div>
                                            </div>
                                        </>
                                    ) : ""
                                }
                                <div className="w-full h-[1px] bg-gray-200"></div>
                            </div>
                        )
                    }
                    {
                        selectedCategoryItem == 0 && selectedCategoryItem.id != 1 && (
                            <div className="px-6  py-2">
                                <div onClick={() => {
                                    setIsShowPrice(!isShowPrice)
                                }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                    <p>
                                        قیمت
                                    </p>
                                    <img className={`transition-all ${isShowPrice ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                </div>
                                {
                                    isShowPrice ? (
                                        <>
                                            <div className="mb-2 flex flex-col">
                                                <div className="flex items-center gap-2">
                                                    <span>از</span>
                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                        <input
                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                            value={priceFrom}
                                                            onChange={(e) => {
                                                                setPriceFrom(e.target.value)
                                                            }}
                                                            pattern='[0-9۰-۹]'
                                                            type="number"
                                                            maxLength={19}
                                                        />
                                                        <span className="p-1 border-r">تومان</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mb-2 flex flex-col">
                                                <div className="flex items-center gap-2">
                                                    <span>تا</span>
                                                    <div className="flex items-center justify-between bg-gray-100 rpinded p-1 rounded w-full">
                                                        <input
                                                            className="w-full px-6 text-right dir-ltr bg-transparent"
                                                            value={priceTo}
                                                            onChange={(e) => setPriceTo(e.target.value)}
                                                            pattern='[0-9۰-۹]'
                                                            type="number"
                                                            maxLength={19}
                                                        />
                                                        <span className="p-1 border-r">تومان</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : ""
                                }
                                <div className="w-full h-[1px] bg-gray-200"></div>
                            </div>
                        )
                    }



                    {
                        selectedMelkMoameleItem && (selectedMelkMoameleItem.id != 4) && (selectedMelkMoameleItem.id != 6) ? (
                            <div className={`px-6  py-2 ${selectedCategoryItem && selectedCategoryItem.id !== 1 ? " opacity-40 pointer-events-none" : "opacity-100 pointer-events-auto"}`}>
                                <div onClick={() => {
                                    setType(!type)
                                    setIsShowOptions(false)
                                    setIsShowAdsDahande(false)
                                    setIsShowLife(false)
                                    setIsShowMetrage(false)
                                    setIsShowRentPerMonth(false)
                                    setIsDeposit(false)
                                }} className="cursor-pointer flex items-center w-full justify-between py-2 ">
                                    <p>نوع آگهی </p>
                                    <img className={`transition-all ${type ? "-rotate-90" : ""}`} src="/icons/arrow-b-f.svg" alt="go" />
                                </div>
                                {
                                    type ? (
                                        <>
                                            <div className="flex justify-between gap-2 mb-2">
                                                <div onClick={() => setAdsAdvertiseTypeCode(adsAdvertiseTypeCode == 0 ? null : 0)} className="flex items-center gap-2">
                                                    <input checked={adsAdvertiseTypeCode == 0 && true} id="all" type="checkbox" />
                                                    <label htmlFor="all">همه</label>
                                                </div>
                                                <div onClick={() => setAdsAdvertiseTypeCode(1)} className="flex items-center gap-2">
                                                    <input checked={adsAdvertiseTypeCode == 0 ? true : adsAdvertiseTypeCode == 1 && true} id="busi" type="checkbox" />
                                                    <label htmlFor="busi">عادی</label>
                                                </div>
                                                <div onClick={() => setAdsAdvertiseTypeCode(2)} className="flex items-center gap-2">
                                                    <input checked={adsAdvertiseTypeCode == 0 ? true : adsAdvertiseTypeCode == 2 && true} id="personal" type="checkbox" />
                                                    <label htmlFor="personal">حراجی</label>
                                                </div>
                                            </div>
                                        </>
                                    ) : ""
                                }
                                <div className="w-full h-[1px] bg-gray-200"></div>
                            </div>
                        ) : ""
                    }
                    {
                        moveToSelectArea ? (
                            <div className="absolute top-0 w-full h-screen bg-white z-50  overflow-auto scroll-filter">
                                <div className="sticky top-0 bg-white">
                                    <div className="flex items-center w-full justify-between border-b p-5">
                                        <p className="font-bold">انتخاب محله</p>
                                        <img onClick={() => setMoveToSelectArea(false)} src="/icons/close-black.svg" alt="close" />
                                    </div>
                                    <div className="p-4">
                                        <div className="bg-gray-100 rounded flex items-center justify-between w-full p-2 ">
                                            <input value={searchInCitiesValue} onChange={(e) => searchInCitiesHandler(e)} className="bg-transparent" type="text" maxLength={320} placeholder="جست و جو محل" />
                                            <img src="/icons/search.svg" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="inline-flex overflow-scroll gap-1 scroll-filter w-[95%] ">
                                    {/* mostatila */}
                                    {
                                        selectedAreas.length > 0 && selectedAreas.map(item => (
                                            <div
                                                onClick={async () => {
                                                    setSelectedAreas(selectedAreas.filter(finallyArea => item.id != finallyArea.id))
                                                }}
                                                className="cursor-pointer rounded-xl border border-[#494949] m-1 px-3 py-1 text-[#494949] flex items-center gap-1 w-max">
                                                <p className="text-sm text-nowrap w-max">{item.locName}</p>
                                                <img src="/icons/new-red-close.svg" className="w-max" alt="حذف" />
                                            </div>
                                        ))
                                    }
                                </div>
                                <div className="px-6 w-full h-screen ">
                                    <div className="flex flex-col gap-2 mb-2">
                                        {
                                            cityState && cityState.length ? cityState.map(item => (
                                                <>
                                                    <div className="flex items-center gap-2 border-b pb-2">
                                                        <label onClick={async () => {
                                                            toggleItem(item)
                                                            setIsShowPrice(!isShowPrice)
                                                            console.log("finally", item);

                                                        }} htmlFor={`location${item.id}`}>
                                                            <div className="flex cursor-pointer  items-center gap-1" >
                                                                <div className={`w-[15px] h-[15px] border rounded-full
                                                             ${selectedAreas.find((area) => area.id == item.id) ? "border-main bg-main" : "border-green-500 bg-white"}`}></div>
                                                                <p>{item.locName}</p>
                                                            </div>
                                                            <p className="">
                                                                {
                                                                    item.subAreas ? item.subAreas.map((sub, index) => (
                                                                        <span className="text-sm text-gray-600 ">{sub}
                                                                            {
                                                                                item.subAreas.length != index + 1 && "-"
                                                                            }
                                                                        </span>
                                                                    )) : ""
                                                                }
                                                            </p>
                                                        </label>
                                                    </div>
                                                </>
                                            )) : ""
                                        }
                                    </div>
                                </div>

                            </div>
                        ) : ""
                    }
                    <div className={`${moveToSelectArea || isShowChoseMoamelePage || isShowChoseMElkTypePage || isShowChoseCategoryPage ? "grid-cols-1 " : "grid-cols-2 "}
                     absolute  bottom-4 w-full grid px-6 py-4 gap-4 border-t bg-white z-50`}>
                        <button onClick={() => filter()} className={`bg-[#F3F3F3] text-[#028E32]
                        ${moveToSelectArea || isShowChoseMoamelePage || isShowChoseMElkTypePage || isShowChoseCategoryPage ? "hidden" : "inline"}
                        rounded  py-1 z-50`}>اعمال فیلتر ها</button>
                        <button onClick={() => {
                            // setIsFilterPrice(true)
                            if (moveToSelectArea) {
                                setMoveToSelectArea(false)
                            }
                            else if (isShowChoseMoamelePage) {
                                setIsShowChoseMoamelePage(false)
                            }
                            else if (isShowChoseMElkTypePage) {
                                setIsShowChoseMElkTypePage(false)
                            }
                            else if (isShowChoseCategoryPage) {
                                setIsShowChoseCategoryPage(false)
                            }
                            else {
                                setIsShowFilters(false)
                            }
                        }} className="text-[#494949] bg-[#F3F3F3] rounded  py-1 z-50">بازگشت</button>
                    </div>
                </div>
            </div >
            {
                !props.isInOnMap && (
                    (storeItems.length && !props.userCode) ?
                        (<>
                            <div className="w-full">
                                <div className='px-[10px] mt-2 w-full' id="adsSection">
                                    <div className={`relative mt-2 grid  sm:grid-cols-1 md:grid-cols-2  gap-[10px] sm:gap-[0px] 
                                                            ${props.userCode ? "grid-cols-2 lg:grid-cols-1 md:grid-cols-1 xl:grid-cols-2 " : "grid-cols-4 lg:grid-cols-3 xl:grid-cols-3  md:grid-cols-2 "} `}
                                    >
                                        {/*  stored  */}    {
                                            auctionItems?.map(auctionItem => <OneCard key={auctionItem.id} item={auctionItem} registerStatusCode={auctionItem.registerStatusCode} />)
                                        }
                                        {
                                            storeItems.filter(storeItem => storeItem.adsAdvertiseTypeCode == 2).map(storeItem => {
                                                return (
                                                    <OneCard key={storeItem.id} item={storeItem} registerStatusCode={storeItem.registerStatusCode}
                                                    />)
                                            }
                                            )
                                        }
                                    </div>
                                </div>
                                <div className='px-[10px] mt-4 sm:mt-1'>
                                    <div className={`relative mt-2 grid  sm:grid-cols-1 md:grid-cols-2  gap-[10px] sm:gap-[0px] 
                                                            ${props.userCode ? "grid-cols-2 lg:grid-cols-1 md:grid-cols-1 xl:grid-cols-2 " : "grid-cols-4 lg:grid-cols-3 xl:grid-cols-3  md:grid-cols-2"} `}
                                    >
                                        {

                                            storeItems.filter(storeItem => storeItem.adsAdvertiseTypeCode !== 2).map(storeItem => (
                                                storeItem.adsAdvertiseShowTypeCode == 2 ?
                                                    (
                                                        <div className="row-span-2 grid">
                                                            {/* <OneCard key={storeItem.id} item={storeItem} registerStatusCode={storeItem.registerStatusCode} /> */}
                                                            <></>
                                                        </div>
                                                    ) : (
                                                        <TwoCard key={storeItem.id} item={storeItem} registerStatusCode={storeItem.registerStatusCode} />
                                                    )
                                            ))
                                        }
                                    </div>
                                </div>
                                <div ref={bottomBoundaryRef} style={{ height: '1px' }} />
                                {hasMoreThanStoreItems &&
                                    (
                                        loader ? (<Loader isLoaderTop={true} />) : (
                                            <>
                                                <InfiniteScroll
                                                    pageStart={0}
                                                    loadMore={fetchData}
                                                    hasMore={hasMore}
                                                    loader={
                                                        <div className="w-full flex items-center justify-center gap-2 font-bold text-center my-4" key={0}>
                                                            <p>  درحال بارگذاری</p>
                                                            <div class="loading">
                                                                <span class="loading__dot"></span>
                                                                <span class="loading__dot"></span>
                                                                <span class="loading__dot"></span>
                                                            </div>
                                                        </div>
                                                    }
                                                >
                                                    <div className='px-[10px] mt-2 w-full ' id="adsSection">
                                                        <div className={`relative mt-2 grid  sm:grid-cols-1 md:grid-cols-2  gap-[10px] sm:gap-[0px] 
                                                                    ${props.userCode ? "grid-cols-2 lg:grid-cols-1 md:grid-cols-1 xl:grid-cols-2 " : "grid-cols-4 lg:grid-cols-3 xl:grid-cols-3  md:grid-cols-2 "} `}
                                                            onClick={() => {
                                                                addItemsInStore(items)
                                                                localStorage.setItem("page", page == 0 ? 20 : page)
                                                            }}
                                                        >
                                                            {
                                                                items.filter(item => item.adsAdvertiseTypeCode == 2).map(item => (
                                                                    <OneCard key={item.id} item={item} registerStatusCode={item.registerStatusCode}
                                                                    />
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className='px-[10px] mt-4 sm:mt-1 w-full'>
                                                        <div className={`relative mt-2 grid  sm:grid-cols-1 md:grid-cols-2  gap-[10px] sm:gap-[0px] 
                                                                    ${props.userCode ? "grid-cols-2 lg:grid-cols-1 md:grid-cols-1 xl:grid-cols-2 " : "grid-cols-4 lg:grid-cols-3 xl:grid-cols-3  md:grid-cols-2"} `}
                                                            onClick={() => {
                                                                addItemsInStore(items)
                                                                localStorage.setItem("page", page == 0 ? 20 : page)
                                                            }}
                                                        >
                                                            {
                                                                items.filter(item => item.adsAdvertiseTypeCode !== 2).map(item => (
                                                                    item.adsAdvertiseShowTypeCode == 2 ? (
                                                                        <div className="row-span-2 grid">
                                                                            <OneCard key={item.id} item={item} registerStatusCode={item.registerStatusCode} />
                                                                        </div>
                                                                    ) : (
                                                                        <TwoCard key={item.id} item={item} registerStatusCode={item.registerStatusCode} />
                                                                    )
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                </InfiniteScroll>
                                            </>
                                        )
                                    )}



                            </div>
                        </>) :
                        <>
                            {
                                (items.length !== 0) ? (
                                    // loader ? (<Loader isLoaderTop={true} />) : (
                                    <div className="w-full">
                                        <InfiniteScroll
                                            pageStart={0}
                                            loadMore={fetchData}
                                            hasMore={hasMore}
                                            loader={
                                                <div className="w-full flex items-center justify-center gap-2 font-bold text-center my-4" key={0}>
                                                    <p>  درحال بارگذاری</p>
                                                    <div class="loading">
                                                        <span class="loading__dot"></span>
                                                        <span class="loading__dot"></span>
                                                        <span class="loading__dot"></span>
                                                    </div>
                                                </div>
                                            }>
                                            <>
                                                <div className='px-[10px] mt-2 w-full ' id="adsSection">
                                                    <div className={`relative mt-2 grid  sm:grid-cols-1 md:grid-cols-2  gap-[10px] sm:gap-[0px] 
                                                                ${props.userCode ? "grid-cols-2 lg:grid-cols-1 md:grid-cols-1 xl:grid-cols-2 " : "grid-cols-4 lg:grid-cols-3 xl:grid-cols-3  md:grid-cols-2 "} `}
                                                        onClick={() => {
                                                            addItemsInStore(items)
                                                            localStorage.setItem("page", page == 0 ? 20 : page)
                                                        }}>


                                                        {
                                                            auctionItems?.map(auctionItem => <OneCard key={auctionItem.id} item={auctionItem} registerStatusCode={auctionItem.registerStatusCode} />)
                                                        }




                                                    </div>
                                                </div>
                                                <div className='px-[10px] mt-4 sm:mt-1'>
                                                    <div className={`relative mt-2 grid  sm:grid-cols-1 md:grid-cols-2  gap-[10px] sm:gap-[0px] 
                                                                ${props.userCode ? "grid-cols-2 lg:grid-cols-1 md:grid-cols-1 xl:grid-cols-2 " : "grid-cols-4 lg:grid-cols-3 xl:grid-cols-3  md:grid-cols-2"} `}
                                                        onClick={() => {
                                                            addItemsInStore(items)
                                                            localStorage.setItem("page", page == 0 ? 20 : page)
                                                        }}>
                                                        {
                                                            items.filter(item => item.adsAdvertiseTypeCode !== 2).map(item => (
                                                                item.adsAdvertiseShowTypeCode == 2 ? (
                                                                    <div className="row-span-2 grid">
                                                                        <OneCard key={item.id} item={item} registerStatusCode={item.registerStatusCode} />
                                                                    </div>
                                                                ) : (
                                                                    <TwoCard key={item.id} item={item} registerStatusCode={item.registerStatusCode} />
                                                                )
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            </>
                                        </InfiniteScroll>
                                    </div>
                                    // )
                                ) : (
                                    loaderFetch ? (
                                        <div className="w-full flex items-center justify-center gap-2 font-bold text-center my-4" key={0}>
                                            <p>  درحال بارگذاری</p>
                                            <div class="loading">
                                                <span class="loading__dot"></span>
                                                <span class="loading__dot"></span>
                                                <span class="loading__dot"></span>
                                            </div>
                                        </div>
                                    ) : (
                                        props.userCode ? (
                                            <div className='flex items-center justify-center flex-col w-full  my-6 gap-2'>
                                                <p className='font-bold text-center'>شما آگهی ثبت نکرده اید</p>
                                                <Link to={"/RegisterAD"}
                                                    className='bg-main px-8 py-1 text-white rounded mb-12'>ثبت آگهی</Link>
                                            </div>
                                        ) : (
                                            <div className='flex items-center justify-center flex-col w-full '>
                                                <p className='font-bold text-center'>آگهی با مشخصات مورد نظر یافت نشد</p>
                                                <button
                                                    onClick={async () => {
                                                        await props.setIsSearch(false)
                                                        props.setSearchValue("")
                                                        localStorage.setItem("locationNameVeeu", JSON.stringify({ id: 3, locName: "تهران" }))
                                                        showAllAdss()
                                                    }}
                                                    className='bg-main px-8 py-1 text-white rounded mb-12'>نمایش همه آگهی ها</button>
                                            </div>
                                        )
                                    )
                                )
                            }
                        </>

                )
            }


        </>
    )
}


export default NewFilter
